import { Link } from "react-router-dom";
import { isLegalEnvironment } from "@frontend/AppSettings/environmentConfig";

const truncateByWords = (text, maxWords) => {
  if (!text) return "";
  const words = text.trim().split(/\s+/);
  if (words.length <= maxWords) return text;
  return words.slice(0, maxWords).join(" ") + "...";
};

const MatterLink = ({ matterid, mattername }) => {
  if (!matterid) return null;
  const label = truncateByWords(mattername || matterid, 7);
  // Align detail route with active environment (legal vs engineering)
  const basePath = isLegalEnvironment ? "/matterDetails" : "/projectDetails";

  return (
    <Link to={`${basePath}/${matterid}`} className="matter-name-text">
      {label}
    </Link>
  );
};

export default MatterLink;


